<template>
    <component :is="icon"/>
</template>

<script>
import IconSchuko from '@/components/icons/plugs/IconSchuko.vue'
import IconType1 from '@/components/icons/plugs/IconType1.vue'
import IconType2 from '@/components/icons/plugs/IconType2.vue'
import IconCCS1 from '@/components/icons/plugs/IconCCS1.vue'
import IconCCS2 from '@/components/icons/plugs/IconCCS2.vue'
import IconCHAdeMO from '@/components/icons/plugs/IconCHAdeMO.vue'
import IconCEEthreePole from '@/components/icons/plugs/IconCEEthreePole.vue'
import IconCEEfivePole from '@/components/icons/plugs/IconCEEfivePole.vue'
import IconTesla from '@/components/icons/plugs/IconTesla.vue'
import IconChargingStation from '@/components/icons/IconChargingStation.vue'

import IconGBtAC from '@/components/icons/plugs/IconGBtAC.vue'
import IconGBtDC from '@/components/icons/plugs/IconGBtDC.vue'
import IconTypeC from '@/components/icons/plugs/IconTypeC.vue'

export default {
    props: {
        icon: {
            type: String,
            default: ''
        }
    },
    components: {
        IconCCS2,
        IconCHAdeMO,
        IconGBtAC,
        IconGBtDC,
        IconCEEthreePole,
        IconCEEfivePole,
        IconTesla,
        IconTypeC,
        IconSchuko,
        IconCCS1,
        IconType1,
        IconType2,
        IconChargingStation
    },
}
</script>